<!-- 
  The UtilStickyBar component is a sticky bar that can be used to e.g. display filters in list modules.
  It has a fixedContent slot for content that should always be visible and an arrowsContent slot for
  content that should be scrollable.
 -->
<template>
  <SharedUtilStickyBar
    :class="isDark ? 'is-dark' : 'is-light'"
    :offset="breakpointState.isLaptopLarge ? -48 : -40"
    :menuIsOpen="headerState.menuOpen">
    <template v-if="slots.fixedContent" #innerFixedContent>
      <slot name="fixedContent"></slot>
    </template>
    <template v-if="slots.arrowsContent" #innerArrowsContent>
      <slot name="arrowsContent"></slot>
    </template>
  </SharedUtilStickyBar>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue';
import { SharedUtilStickyBar } from '@seb-platform/shared/components/storyblok';
import { useBreakpoint } from '@seb-platform/shared/composables';
import { useHeader } from '~/composables/useHeader';

defineProps<{ isDark?: boolean }>();

const { state: headerState } = useHeader();
const { state: breakpointState } = useBreakpoint();
const slots = useSlots();
</script>

<style src="./UtilStickyBar.scss" lang="scss" scoped />
